import { elaineMediaArray } from './elaineMedia'
import { elaineBio } from './elaineBios'
import { georgeProfileReviewHinge, jerryProfileReviewBumble, kramerProfileReviewTinder } from './elaineProfileReviews'

export const elaineDatingProfileHinge = {
  _id: 'elaineDatingProfileHingeId',
  userId: 'elaineUserId',
  email: 'elaine@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: elaineMediaArray[16]._id,
      mediaItemURL: elaineMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[16].type,
      caption: elaineMediaArray[16].captions[2],
      subcaption: elaineMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[2]._id,
      mediaItemURL: elaineMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[2].type,
      caption: elaineMediaArray[2].captions[1],
      subcaption: elaineMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[1]._id,
      mediaItemURL: elaineMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[1].type,
      caption: elaineMediaArray[1].captions[2],
      subcaption: elaineMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[12]._id,
      mediaItemURL: elaineMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[12].type,
      caption: elaineMediaArray[12].captions[2],
      subcaption: elaineMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[7]._id,
      mediaItemURL: elaineMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[7].type,
      caption: elaineMediaArray[7].captions[1],
      subcaption: elaineMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[13]._id,
      mediaItemURL: elaineMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[13].type,
      caption: elaineMediaArray[13].captions[0],
      subcaption: elaineMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: elaineBio._id,
    vitalInfo: { ...elaineBio.vitalInfo },
    prompts: [
      { ...elaineBio.prompts[0] },
      { ...elaineBio.prompts[1] },
      { ...elaineBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...georgeProfileReviewHinge }
  ],
  mediaItems: [ ...elaineMediaArray ],
  bioItems: { ...elaineBio },
}

export const elaineDatingProfileBumble = {
  _id: 'elaineDatingProfileBumbleId',
  userId: 'elaineUserId',
  email: 'elaine@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: elaineMediaArray[16]._id,
      mediaItemURL: elaineMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[16].type,
      caption: elaineMediaArray[16].captions[2],
      subcaption: elaineMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[2]._id,
      mediaItemURL: elaineMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[2].type,
      caption: elaineMediaArray[2].captions[1],
      subcaption: elaineMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[1]._id,
      mediaItemURL: elaineMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[1].type,
      caption: elaineMediaArray[1].captions[2],
      subcaption: elaineMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[12]._id,
      mediaItemURL: elaineMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[12].type,
      caption: elaineMediaArray[12].captions[2],
      subcaption: elaineMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[7]._id,
      mediaItemURL: elaineMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[7].type,
      caption: elaineMediaArray[7].captions[1],
      subcaption: elaineMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[13]._id,
      mediaItemURL: elaineMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[13].type,
      caption: elaineMediaArray[13].captions[0],
      subcaption: elaineMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: elaineBio._id,
    vitalInfo: { ...elaineBio.vitalInfo },
    prompts: [
      { ...elaineBio.prompts[0] },
      { ...elaineBio.prompts[1] },
      { ...elaineBio.prompts[2] }
    ],
    aboutMe: elaineBio.aboutMe[0],
    hobbies: [elaineBio.hobbies[0], elaineBio.hobbies[1], elaineBio.hobbies[2], elaineBio.hobbies[3], elaineBio.hobbies[4] ],
  },
  profileReviews: [
    { ...jerryProfileReviewBumble }
  ],
  mediaItems: [ ...elaineMediaArray ],
  bioItems: { ...elaineBio },
}

export const elaineDatingProfileTinder = {
  _id: 'elaineDatingProfileTinderId',
  userId: 'elaineUserId',
  email: 'elaine@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: elaineMediaArray[16]._id,
      mediaItemURL: elaineMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[16].type,
      caption: elaineMediaArray[16].captions[2],
      subcaption: elaineMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[2]._id,
      mediaItemURL: elaineMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[2].type,
      caption: elaineMediaArray[2].captions[1],
      subcaption: elaineMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[1]._id,
      mediaItemURL: elaineMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[1].type,
      caption: elaineMediaArray[1].captions[2],
      subcaption: elaineMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[12]._id,
      mediaItemURL: elaineMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[12].type,
      caption: elaineMediaArray[12].captions[2],
      subcaption: elaineMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[7]._id,
      mediaItemURL: elaineMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[7].type,
      caption: elaineMediaArray[7].captions[1],
      subcaption: elaineMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[13]._id,
      mediaItemURL: elaineMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[13].type,
      caption: elaineMediaArray[13].captions[0],
      subcaption: elaineMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: elaineBio._id,
    vitalInfo: { ...elaineBio.vitalInfo },
    prompts: [
      { ...elaineBio.prompts[0] },
      { ...elaineBio.prompts[1] },
      { ...elaineBio.prompts[2] }
    ],
    aboutMe: elaineBio.aboutMe[0],
    hobbies: [elaineBio.hobbies[0], elaineBio.hobbies[1], elaineBio.hobbies[2], elaineBio.hobbies[3], elaineBio.hobbies[4] ],
  },
  profileReviews: [
    { ...kramerProfileReviewTinder }
  ],
  mediaItems: [ ...elaineMediaArray ],
  bioItems: { ...elaineBio },
}